import React, { useState } from 'react';
import styled from 'styled-components';
import Fade from 'react-reveal/Fade';
import Typography from '../../Typography';
import { PatentDescription } from './PatentDescription';
import { PatentsSection, PatentHeading, Subtitle, PatentsDescription, PatentNumbers, USPatents, PatentsList, USPatentApplications, PatentsReference, Patent } from '../index.styled'

const PatentsContainer = styled.div``

const PatentsButton = styled.div`
  font-family: 'ToyotaType Bold';
  font-size: 13px;
	line-height: 32px;
	letter-spacing: 0.05em;
  display: ${({expanded}) => expanded ? 'none' : 'flex'};
  justify-content: space-between;
  width: 90%;
  & > div {
    font-family: 'ToyotaType Book';
    font-size: 20px;
  }
`
const ButtonWrapper = styled.div`
  display: ${({expanded}) => expanded ? 'none': 'flex'};
  justify-content: center;
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  height: 35px;
  width: 90%;
`
const Close = styled.button`
  border: none;
  background: none;
  font-family: 'ToyotaType Book';
`
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`
const PatentTitle = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
`

const language = (window.localStorage.i18nextLng === 'ja') ? 'ja' : 'en';

export const PatentsCollapsed = ({goToContact, patents}) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <Wrapper>
      <ButtonWrapper expanded={expanded}>
        <PatentsButton onClick={()=>setExpanded(!expanded)}>
          <span>{patents.title}</span>
          <div>+</div>
        </PatentsButton>
      </ButtonWrapper>
      {
        expanded && (
          <Fade>
            <PatentsContainer>
                  {
                    (language === 'en') ? (
                      <PatentsSection>
                        <PatentHeading>
                          <PatentTitle>
                            <Typography.BodyBold>{patents.title}</Typography.BodyBold>
                            <Close onClick={()=>setExpanded(!expanded)}>
                              &#10005;
                            </Close>
                          </PatentTitle>
                          <Subtitle>{patents.headline}</Subtitle>
                          <PatentsDescription> 
                            {
                              (patents.list.length > 0) && (
                                <Typography.BodySmall>
                                  <PatentDescription goToContact={()=>{goToContact()}} description={patents.description} />
                                </Typography.BodySmall>
                              )
                            }
                          </PatentsDescription>
                        </PatentHeading>
                        <PatentNumbers>
                          {
                            (patents.list.length > 0) && (
                              <USPatents>
                                <Subtitle>{patents.usPatents}</Subtitle>
                                <PatentsList patents={patents.list.length} >
                                  {patents.list.map(patent => <Patent key={patent}>{patent}</Patent>)}
                                </PatentsList>
                              </USPatents>
                            )
                          }
                          {
                            (patents.applications.length > 0) && (
                              <USPatentApplications>
                                <Subtitle>{patents.usPatentsApplications}</Subtitle>
                                <PatentsList patents={patents.applications.length}>
                                  {patents.applications.map(application => (
                                    <Patent key={application}>{application}</Patent>
                                  ))}
                                </PatentsList>
                              </USPatentApplications>
                            ) 
                          }
                        </PatentNumbers>
                        <PatentHeading>
                          <PatentsDescription>
                          {
                            (patents.jpList && patents.jpList.length > 0) && (
                              <Typography.BodySmall>
                              <PatentDescription goToContact={()=>{goToContact()}} description={patents.jpDescription} />
                            </Typography.BodySmall>
                            ) 
                          }
                          </PatentsDescription>
                        </PatentHeading>
                        <PatentNumbers>
                          {
                            (patents.jpList && patents.jpList.length > 0) && (
                              <USPatents>
                                <Subtitle>{patents.jpPatents}</Subtitle>
                                <PatentsList patents={patents.jpList.length} >
                                  {patents.jpList.map(patent => <Patent key={patent}>{patent}</Patent>)}
                                </PatentsList>
                              </USPatents>
                            )
                          }
                          {
                            (patents.jpApplications && patents.jpApplications.length > 0) && (
                              <USPatentApplications>
                                <Subtitle>{patents.jpPatentsApplications}</Subtitle>
                                <PatentsList patents={patents.jpApplications.length}>
                                  {patents.jpApplications.map(application => (
                                    <Patent key={application}>{application}</Patent>
                                  ))}
                                </PatentsList>
                              </USPatentApplications>
                            ) 
                          }
                        </PatentNumbers>
                        <PatentsReference>
                          {patents.disclaimers.map(disclaimer => <span key={disclaimer}>{disclaimer}</span>)}
                        </PatentsReference>
                      </PatentsSection>
                    ) : (
                      <PatentsSection> 
                        <PatentHeading>
                          <PatentTitle>
                            <Typography.BodyBold>{patents.title}</Typography.BodyBold>
                          </PatentTitle>
                          <Subtitle>{patents.headline}</Subtitle>
                          <PatentsDescription> 
                          {
                            (patents.jpList && patents.jpList.length > 0) && (
                              <Typography.BodySmall>
                              <PatentDescription goToContact={()=>{goToContact()}} description={patents.jpDescription} />
                            </Typography.BodySmall>
                            ) 
                          }
                          </PatentsDescription>
                        </PatentHeading>
                        <PatentNumbers>
                          {
                            (patents.jpList && patents.jpList.length > 0) && (
                              <USPatents>
                                <Subtitle>{patents.jpPatents}</Subtitle>
                                <PatentsList patents={patents.jpList.length} >
                                  {patents.jpList.map(patent => <Patent key={patent}>{patent}</Patent>)}
                                </PatentsList>
                              </USPatents>
                            )
                          }
                          {
                            (patents.jpApplications && patents.jpApplications.length > 0) && (
                              <USPatentApplications>
                                <Subtitle>{patents.jpPatentsApplications}</Subtitle>
                                <PatentsList patents={patents.jpApplications.length}>
                                  {patents.jpApplications.map(application => (
                                    <Patent key={application}>{application}</Patent>
                                  ))}
                                </PatentsList>
                              </USPatentApplications>
                            ) 
                          }
                        </PatentNumbers>
                        <PatentHeading>
                          <PatentsDescription> 
                            {
                              (patents.list.length > 0) && (
                                <Typography.BodySmall>
                                  <PatentDescription goToContact={()=>{goToContact()}} description={patents.description} />
                                </Typography.BodySmall>
                              )
                            }
                          </PatentsDescription>
                        </PatentHeading>
                        <PatentNumbers>
                          {
                            (patents.list.length > 0) && (
                              <USPatents>
                                <Subtitle>{patents.usPatents}</Subtitle>
                                <PatentsList patents={patents.list.length} >
                                  {patents.list.map(patent => <Patent key={patent}>{patent}</Patent>)}
                                </PatentsList>
                              </USPatents>
                            )
                          }
                          {
                            (patents.applications.length > 0) && (
                              <USPatentApplications>
                                <Subtitle>{patents.usPatentsApplications}</Subtitle>
                                <PatentsList patents={patents.applications.length}>
                                  {patents.applications.map(application => (
                                    <Patent key={application}>{application}</Patent>
                                  ))}
                                </PatentsList>
                              </USPatentApplications>
                            ) 
                          }
                        </PatentNumbers>
                        <PatentsReference>
                          {patents.disclaimers.map(disclaimer => <span key={disclaimer}>{disclaimer}</span>)}
                        </PatentsReference>
                    </PatentsSection>
                    )
                  }
              </PatentsContainer>
          </Fade>
        )
      }
    </Wrapper>
  )
}